// extracted by mini-css-extract-plugin
export var truncate = "_l-0";